import { gql } from "@apollo/client";

export const GET_DELEGATIONS = gql`
  query Delegations {
    Delegations {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_CG_USER_ROLE_ASSIGMENTS = gql`
  query getCgUserRoleAssignments {
    cgUserRoleAssignments {
      Role_Assignment_ID
      User_ID {
        User_ID
        User_Name
        User_Type_ID
        First_Name
        Last_Name
      }
      Role_ID {
        Role_ID
        Title
      }
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      SEPC_ID {
        SEPC_ID
        Parastatal_Code
        Parastatal_Name
      }
      Programme_ID
      Sub_SubProgramme_ID
      Department_ID
      Project_ID
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_LG_USER_ROLE_ASSIGMENTS = gql`
  query getLgUserRoleAssignments {
    lgUserRoleAssignments {
      Role_Assignment_ID
      User_ID {
        User_ID
        User_Name
        User_Type_ID
        First_Name
        Last_Name
      }
      Role_ID {
        Role_ID
        Title
      }
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      Sub_SubProgramme_ID
      Service_Area_ID
      LLG_ID
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

export const GET_ACTIVE_DELEGATIONS = gql`
  query ActiveDelegations {
    activeDelegation {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;
// Get single delegation by ID
export const GET_DELEGATION_BY_ID = gql`
  query GetDelegation($id: Int!) {
    Delegation(id: $id) {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

// Get delegations by user name
export const GET_DELEGATIONS_BY_USER = gql`
  query GetDelegationsByUser($User_Name: String!) {
    getDelegationbyUser(User_Name: $User_Name) {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

// Get delegation details with additional info
export const GET_DELEGATION_DETAILS = gql`
  query GetDelegationDetails($Report_Delegation_ID: Int!) {
    getDelegationDetails(Report_Delegation_ID: $Report_Delegation_ID) {
      Report_Delegation_ID
      Year_ID
      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }
      LG_Vote_ID
      User_ID
      Alternate_User_ID
      Start_Date
      End_Date
      Comments
      Has_Consented
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

// Get current user's vote
export const GET_CURRENT_USER_VOTE = gql`
  query GetCurrentUserVote {
    getCurrentUserVoteById {
      Vote_ID
      Vote_Code
      Vote_Name
      # Add other CgVoteDto fields you need
    }
  }
`;

